type RegexMatch = {
  fullMatch: string;
  tagName: string;
  id: string;
  content: string;
};

export const extractIdFromHtml = (htmlString: string, idSubstring: string) => {
  // Regex for partial match of the ID
  const regex = new RegExp(
    `<([a-zA-Z][a-zA-Z0-9]*)[^>]*\\bid="([^"]*${idSubstring}[^"]*)"[^>]*>(.*?)</\\1>`,
    'gis',
  );

  // Find all matches
  const matches: RegexMatch[] = [];
  let match;
  while ((match = regex.exec(htmlString)) !== null) {
    matches.push({
      fullMatch: match[0], // Full matched element
      tagName: match[1], // Tag name
      id: match[2], // Captured ID
      content: match[3], // Inner content
    });
  }

  // // Output the matches
  // if (matches.length > 0) {
  //   matches.forEach((m, index) => {
  //     console.log(`Match ${index + 1}:`);
  //     console.log('Matched Element:', m.fullMatch);
  //     console.log('Tag Name:', m.tagName);
  //     console.log('ID:', m.id);
  //     console.log('Content:', m.content);
  //   });
  // } else {
  //   console.log('No elements found with the specified ID.');
  // }
  return matches;
};

export const domParser = (htmlString: string, idSubstring: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  // Find all elements with IDs containing the substring
  return doc.querySelectorAll(`[id*="${idSubstring}"]`);
};
